export default __webpack_public_path__ + "static/whole-d5a4c4dead28d6afa21119c9696452d4.png";